import { render, staticRenderFns } from "./FieldsQuestion.vue?vue&type=template&id=9234ace0&scoped=true"
import script from "./FieldsQuestion.vue?vue&type=script&lang=js"
export * from "./FieldsQuestion.vue?vue&type=script&lang=js"
import style0 from "./FieldsQuestion.vue?vue&type=style&index=0&id=9234ace0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9234ace0",
  null
  
)

export default component.exports